<template>
  <div class="flex items-center gap-2 mt-0.5">
    <div
      type="button"
      class="quantity-button"
      :class="collapsed ? 'opacity-0 translate-x-1' : ''"
      :disabled="props.decrementDisabled || undefined"
      @click.stop="props.decrementDisabled ? null : emit('decrement')"
    >
      <Icon
        name="minus"
        class="w-4 h-auto"
      />
    </div>
    <div
      class="min-w-4 text-center transition-all duration-300 font-medium"
      data-cy="ticket-quantity"
      :class="collapsed ? 'opacity-0 translate-x-1' : ''"
    >
      {{ props.quantity }}
    </div>
    <div
      type="button"
      class="quantity-button"
      :disabled="props.incrementDisabled || undefined"
      @click.stop="props.incrementDisabled ? null : emit('increment')"
    >
      <Icon
        name="plus"
        class="w-4 h-auto"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  quantity: {
    type: Number,
    default: 0,
  },
  decrementDisabled: {
    type: Boolean,
    default: false,
  },
  incrementDisabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['decrement', 'increment']);

// Computed
const collapsed = computed(() => props.quantity === 0);
</script>

<style scoped>
.quantity-button {
  @apply flex items-center justify-center size-6 bg-gray-200 rounded transition-all duration-300 text-gray-700 cursor-pointer;
  @apply hover:enabled:bg-gray-300;

  &[disabled] {
    @apply pointer-events-none bg-gray-100 text-gray-300 cursor-not-allowed;
  }
}
</style>
